import { Textarea } from "@/components/ui/textarea";
import { FileText, Award, Sparkles } from "lucide-react";
import { Card, SecTitle, Chip, Evidence } from "./parts";

export function OverviewTab({ p, editing, set }) {
  const ri = p.recruitment_intelligence || {};
  return (
    <div className="space-y-5">
      <Card><SecTitle icon={FileText} conf={p.confidence?.summary}>Professional summary</SecTitle>
        {editing ? <Textarea value={p.summary || ""} onChange={(e) => set("summary", e.target.value)} rows={3} data-testid="edit-summary" />
          : <p className="text-sm leading-relaxed text-foreground/80">{p.summary || "—"}</p>}
        <div className="mt-2"><Evidence text={p.evidence?.summary} /></div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4">
          {[["Seniority", p.seniority || ri.seniority], ["Domain", p.primary_domain || ri.primary_profession], ["Specialization", p.functional_specialization], ["Experience", p.total_years != null ? `${p.total_years} yrs` : ri.total_experience]].map(([l, v], i) => v ? (
            <div key={i} className="rounded-lg border border-border/60 bg-card/50 p-2.5"><div className="text-[10px] uppercase tracking-wider text-muted-foreground">{l}</div><div className="text-sm font-medium mt-0.5">{v}</div></div>
          ) : null)}
        </div>
      </Card>
      {(p.achievements || []).length > 0 && (
        <Card><SecTitle icon={Award}>Career highlights</SecTitle>
          <ul className="space-y-2">{(p.achievements || []).map((a, i) => <li key={i} className="flex gap-2 text-sm text-foreground/80"><span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-emerald-400 shrink-0" />{a}</li>)}</ul>
        </Card>
      )}
      <Card><SecTitle icon={Sparkles} conf={p.confidence?.skills}>Top skills</SecTitle>
        <div className="flex flex-wrap gap-2">{(p.skills || []).slice(0, 14).map((s, i) => <Chip key={i}>{typeof s === "string" ? s : s.name}</Chip>)}</div>
      </Card>
    </div>
  );
}
